import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FormInputComponent } from '@app/shared/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
    selector: 'app-quiz-answer',
    templateUrl: './quiz-answer.component.html',
    styleUrls: ['./quiz-answer.component.css'],
    imports: [
        ReactiveFormsModule,
        TranslateModule,
        ButtonModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputTextModule,
        RadioButtonModule,
        FormInputComponent,
    ],
})
export class QuizAnswerComponent {
    readonly control = input.required<FormControl<string>>();
    readonly index = input.required<number>();
    readonly correctAnswer = input.required<FormControl<number>>();
    readonly canRemove = input.required<boolean>();
    readonly testId = input.required<string>();

    readonly remove = output<void>();
}
